var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 328,
    viewBox: "0 0 313 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -11,
    y: -8,
    width: 335,
    height: 431
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.695 9.56599L11.9999 -7.15112L-10.1723 406.255L301.523 422.972L323.695 9.56599Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_729)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_130_729",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -126,
    y: -172,
    width: 601,
    height: 653
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.834 -171.744L474.429 304.986L96.0242 480.876L-125.57 4.14627L252.834 -171.744Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_130_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.876 295.178C172.312 300.757 141.641 299.538 111.83 291.535C112.411 280.864 107.172 270.68 98.0689 265.084C77.0025 252.134 59.7259 232.467 49.8449 207.755C49.0642 205.802 48.3445 203.825 47.6553 201.836C26.8028 140.569 58.6674 72.9083 121.021 50.8783C178.56 30.5256 243.317 57.7833 268.935 113.181C284.386 146.601 283.112 183.063 268.97 213.629C259.089 235.025 242.827 253.559 221.592 266.119C211.2 272.256 204.512 283.14 203.876 295.178Z",
    fill: "#3A3A3B",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.871 295.166C172.308 300.744 141.636 299.526 111.825 291.523C112.41 280.85 107.167 270.668 98.0642 265.071C77.0008 252.12 59.7242 232.453 49.8432 207.741C49.0625 205.788 48.3398 203.813 47.6506 201.824C26.8011 140.555 58.6627 72.896 121.016 50.866C178.555 30.5133 243.312 57.771 268.93 113.169C284.384 146.587 283.11 183.049 268.966 213.617C259.085 235.013 242.822 253.547 221.587 266.107C211.196 272.244 204.507 283.128 203.871 295.166Z",
    stroke: "#3A3A3B",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.202 226.651L140.976 213.458C140.834 205.593 135.924 198.382 128.435 195.989C123.497 194.408 118.174 194.961 114.553 201.826C106.38 217.292 123.901 223.573 133.203 225.734C135.815 226.365 138.482 226.647 141.202 226.651Z",
    stroke: "#3A3A3B",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.309 225.974L180.083 212.782C179.941 204.916 184.576 197.504 191.972 194.863C196.844 193.106 202.199 193.479 206.049 200.204C214.76 215.359 197.467 222.274 188.293 224.763C185.659 225.48 183.004 225.848 180.309 225.974Z",
    stroke: "#3A3A3B",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55 295.291L180.99 264.318L180.735 249.653L180.307 226.445L180.309 225.973C179.953 225.994 179.629 226 179.279 226.018L160.759 226.328L142.228 226.684C141.903 226.687 141.539 226.675 141.202 226.651L141.2 227.122L141.842 261.391L141.884 264.052L142.456 295.998",
    stroke: "#3A3A3B",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92 363.461C191.981 368.177 179.645 370.792 167.381 371.532C155.114 372.27 142.918 371.054 131.212 368.086C129.448 367.642 127.696 367.148 125.977 366.646C121.506 365.282 118.519 361.123 118.49 356.463L118.431 294.209C148.635 300.569 179.326 300.104 210.538 292.81L210.607 353.682C210.618 357.993 207.978 361.901 203.92 363.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.717 80.6051C205.818 105.12 245.364 171.694 238.469 239.644C249.719 228.745 258.748 215.196 264.485 199.493C284.802 143.892 256.192 82.3429 200.588 62.0277C167.838 50.0648 133.038 55.0882 105.8 72.5859C116.821 74.0177 127.848 76.6316 138.717 80.6051Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.906 296.822L201.35 360.62",
    stroke: "#CECECE",
    strokeWidth: 13.1429,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.386 368.871C161.296 368.342 159.226 367.761 157.191 367.163C151.897 365.551 148.369 360.633 148.334 355.117L148.276 298.464C138.6 297.82 128.967 296.569 119.392 294.552L119.451 356.806C119.48 361.467 122.463 365.624 126.938 366.989C128.658 367.494 130.407 367.982 132.171 368.434C143.878 371.395 156.075 372.613 168.338 371.877C170.537 371.743 172.735 371.529 174.935 371.274C171.051 370.627 167.194 369.836 163.386 368.871Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.722 83.6112C225.152 91.3543 243.079 109.928 250.883 132.392",
    stroke: "#363636",
    strokeWidth: 6.57143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.552 181.623C254.688 171.727 255.746 161.648 254.979 151.892",
    stroke: "#363636",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92 363.461C191.981 368.177 179.645 370.792 167.381 371.532C155.114 372.27 142.918 371.054 131.212 368.086C129.448 367.642 127.696 367.148 125.977 366.646C121.506 365.282 118.519 361.123 118.49 356.463L118.431 294.209C148.635 300.569 179.326 300.104 210.538 292.81L210.607 353.682C210.618 357.993 207.978 361.901 203.92 363.461Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.149 361.046L120.393 348.208L120.38 334.945L208.737 348.49L208.733 352.589C208.731 356.029 206.98 359.209 204.149 361.046Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.674 308.67L148.189 299.407C168.11 300.709 188.259 298.985 208.666 294.224L208.674 308.67Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.737 348.49L120.377 334.947L120.364 321.682L208.706 335.196L208.737 348.49Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.711 335.197L120.364 321.681L120.378 308.399L208.694 321.933L208.711 335.197Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69 321.931L120.376 308.403L120.349 295.56C129.596 297.516 138.872 298.795 148.187 299.403L208.671 308.671L208.69 321.931Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.149 361.047C203.56 361.422 202.959 361.698 202.319 361.966C192.309 365.92 182.008 368.353 171.734 369.338L171.704 369.352L122.839 361.836C121.312 360.046 120.403 357.726 120.403 355.255L120.393 348.209L204.149 361.047Z",
    stroke: "#393939",
    strokeWidth: 6.57143,
    strokeMiterlimit: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.335 317.547L113.167 315.197L108.064 410.346L213.056 415.977L218.335 317.547Z",
    fill: "#3B3838"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312.143,
    height: 421.14,
    fill: "white",
    transform: "translate(0.51355 0.910339)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.86f06e25c9134eee1334204c6d0d8990.svg";
export { ForwardRef as ReactComponent };